export default __webpack_public_path__ + "5b62c3068537e4c1001fd928366a2eb2.svg";